// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Expln_React_Dialog = require("../react-mui-components/Expln_React_Dialog.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var Expln_utils_promise = require("../Expln_utils_promise.bs.js");

function useModalRef(param) {
  return React.useRef(null);
}

function modalRefToModalMethods(modalRef) {
  var modalMethods = modalRef.current;
  if (modalMethods == null) {
    return Js_exn.raiseError("modalRef.current is null");
  } else {
    return modalMethods;
  }
}

function openModal(modalRef, render) {
  return Curry._1(modalRefToModalMethods(modalRef).openModal, render);
}

function openModalFullScreen(modalRef, render) {
  return Curry._1(modalRefToModalMethods(modalRef).openModalFullScreen, render);
}

function updateModal(modalRef, modalId, render) {
  Curry._2(modalRefToModalMethods(modalRef).updateModal, modalId, render);
}

function closeModal(modalRef, modalId) {
  Curry._1(modalRefToModalMethods(modalRef).closeModal, modalId);
}

function openModalPriv(st, fullScreen, render) {
  var id = String(st.nextId);
  return [
          {
            nextId: st.nextId + 1 | 0,
            modals: st.modals.concat([{
                    id: id,
                    fullScreen: fullScreen,
                    render: render
                  }])
          },
          id
        ];
}

function Expln_React_Modal(props) {
  var match = React.useState(function () {
        return {
                nextId: 0,
                modals: []
              };
      });
  var setState = match[1];
  props.modalRef.current = React.useMemo((function () {
          return {
                  openModal: (function (render) {
                      return Expln_utils_promise.promise(function (rlv) {
                                  Curry._1(setState, (function (prev) {
                                          var match = openModalPriv(prev, false, render);
                                          Curry._1(rlv, match[1]);
                                          return match[0];
                                        }));
                                });
                    }),
                  openModalFullScreen: (function (render) {
                      return Expln_utils_promise.promise(function (rlv) {
                                  Curry._1(setState, (function (prev) {
                                          var match = openModalPriv(prev, true, render);
                                          Curry._1(rlv, match[1]);
                                          return match[0];
                                        }));
                                });
                    }),
                  updateModal: (function (modalId, render) {
                      Curry._1(setState, (function (__x) {
                              return {
                                      nextId: __x.nextId,
                                      modals: __x.modals.map(function (m) {
                                            if (m.id === modalId) {
                                              return {
                                                      id: m.id,
                                                      fullScreen: m.fullScreen,
                                                      render: render
                                                    };
                                            } else {
                                              return m;
                                            }
                                          })
                                    };
                            }));
                    }),
                  closeModal: (function (modalId) {
                      Curry._1(setState, (function (__x) {
                              return {
                                      nextId: __x.nextId,
                                      modals: __x.modals.filter(function (m) {
                                            return m.id !== modalId;
                                          })
                                    };
                            }));
                    })
                };
        }), []);
  return React.createElement(React.Fragment, undefined, match[0].modals.map(function (modal) {
                  return JsxPPXReactSupport.createElementWithKey(modal.id, Expln_React_Dialog.make, {
                              opn: true,
                              fullScreen: modal.fullScreen,
                              maxWidth: modal.fullScreen ? undefined : "xl",
                              children: Curry._1(modal.render, undefined)
                            });
                }));
}

var make = Expln_React_Modal;

exports.useModalRef = useModalRef;
exports.openModal = openModal;
exports.openModalFullScreen = openModalFullScreen;
exports.updateModal = updateModal;
exports.closeModal = closeModal;
exports.make = make;
/* react Not a pure module */
